import { render } from "./ModalNuovoInterventoFromTicket.vue?vue&type=template&id=07dd8bcb&scoped=true"
import script from "./ModalNuovoInterventoFromTicket.vue?vue&type=script&lang=js"
export * from "./ModalNuovoInterventoFromTicket.vue?vue&type=script&lang=js"

import "./ModalNuovoInterventoFromTicket.vue?vue&type=style&index=0&id=07dd8bcb&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1770887991853013682/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dd8bcb"]])

export default __exports__